import { differenceInCalendarDays, format, isToday, isYesterday } from "date-fns";

/**
 * Relative-then-absolute timestamp for Artifact Library rows/cards on both web
 * and native, the common pattern:
 *   today        → exact time ("2:30 PM")
 *   yesterday    → "Yesterday"
 *   2–6 days ago → "N days ago"
 *   this year    → "Jun 9"
 *   older        → "Jun 9, 2024"
 */
export const formatLibraryDate = (value: string | Date): string => {
  const date = new Date(value);
  if (isToday(date)) return format(date, "h:mm a");
  if (isYesterday(date)) return "Yesterday";

  const daysAgo = differenceInCalendarDays(new Date(), date);
  if (daysAgo > 0 && daysAgo < 7) return `${daysAgo} days ago`;

  return format(date, date.getFullYear() === new Date().getFullYear() ? "MMM d" : "MMM d, yyyy");
};
